export default __webpack_public_path__ + "static/media/texture-home.db58e983.jpg";